"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallBackSuccess = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const vanillaOidc_js_1 = require("../../vanilla/vanillaOidc.js");
const withRouter_js_1 = require("../routes/withRouter.js");
const AuthenticateError_component_js_1 = __importDefault(require("./AuthenticateError.component.js"));
const CallBackSuccess = () => ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "oidc-callback" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "oidc-callback__container" }, { children: [(0, jsx_runtime_1.jsx)("h1", Object.assign({ className: "oidc-callback__title" }, { children: "Authentication complete" })), (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "oidc-callback__content" }, { children: "You will be redirected to your application." }))] })) })));
exports.CallBackSuccess = CallBackSuccess;
const CallbackManager = ({ callBackError, callBackSuccess, configurationName, withCustomHistory }) => {
    const [isError, setIsError] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        let isMounted = true;
        const playCallbackAsync = () => __awaiter(void 0, void 0, void 0, function* () {
            const getOidc = vanillaOidc_js_1.VanillaOidc.get;
            try {
                const { callbackPath } = yield getOidc(configurationName).loginCallbackAsync();
                const history = (withCustomHistory) ? withCustomHistory() : (0, withRouter_js_1.getCustomHistory)();
                history.replaceState(callbackPath || '/');
            }
            catch (error) {
                if (isMounted) {
                    setIsError(true);
                }
            }
        });
        playCallbackAsync();
        return () => {
            isMounted = false;
        };
    }, []);
    const CallbackErrorComponent = callBackError || AuthenticateError_component_js_1.default;
    const CallbackSuccessComponent = callBackSuccess || exports.CallBackSuccess;
    if (isError) {
        return (0, jsx_runtime_1.jsx)(CallbackErrorComponent, { configurationName: configurationName });
    }
    return (0, jsx_runtime_1.jsx)(CallbackSuccessComponent, { configurationName: configurationName });
};
exports.default = CallbackManager;
//# sourceMappingURL=Callback.component.js.map